<template>
  <v-app-bar
    :collapse="collapse"
    dark
    dense
    scroll-target="#scrolling-techniques-6"
    class="app-bar"
    app
  >
    <v-app-bar-nav-icon @click="collapse = !collapse"></v-app-bar-nav-icon>

    <v-toolbar-title></v-toolbar-title>

    <v-spacer></v-spacer>
    <v-btn
      class="mr-2"
      exact
      text
      active-class="active-button"
      :to="{ name: 'Welcome' }"
      v-if="!collapse"
      >Welcome</v-btn
    >
    <v-btn
      exact
      text
      active-class="active-button"
      :to="{ name: 'About' }"
      v-if="!collapse"
      >About</v-btn
    >
    <v-btn
      exact
      text
      active-class="active-button"
      :to="{ name: 'Portfolio' }"
      v-if="!collapse"
      >Portfolio</v-btn
    >
    <v-btn
      exact
      text
      active-class="active-button"
      :to="{ name: 'Contact' }"
      v-if="!collapse"
      >Contact</v-btn
    >
  </v-app-bar>
</template>

<script>
export default {
  data() {
    return {
      collapse: true
    }
  }
  // computed: {
  // collapse() {
  //   switch (this.$route.name) {
  //     case 'About':
  //       return false
  //     case 'Catalogue':
  //       return false
  //     default:
  //       return true
  //   }
  // }
  // },
  // computed: {
  //   currentRouteName() {
  //     return this.this.$route.name
  //   }
  // },
  // watch: {
  //   currentRouteName() {
  //     switch (this.$route.name) {
  //       case 'About':
  //         this.collapse = false
  //         break
  //       case 'Catalogue':
  //         this.collapse = false
  //         break
  //       default:
  //         this.collapse = true
  //         break
  //     }
  //   }
  // }
}
</script>

<style scoped>
.v-btn:hover {
  border-radius: 30px;
}
.active-button {
  text-shadow: 0px 0px 10px rgba(255, 255, 255, 0.88);
}
.theme--dark.v-btn--active::before {
  opacity: 0.09;
  border-radius: 30px;
}
.theme--dark.v-btn--active:hover::before {
  opacity: 0.09;
}

.app-bar {
  z-index: 100 !important;
  background-color: transparent !important;
  background: linear-gradient(
    234deg,
    rgba(12, 43, 70, 0.7) 24%,
    rgba(50, 100, 107, 0.7) 76%
  );
}

.active-button {
  background: transparent;
}
</style>
